<template>
  <div class="outline" v-for="item in adviceList" :key="item.advID">
    <ul>
      <li>
        <a href="javascript:;" @click="showAdvice(item.advID)">{{
          item.advName
        }}</a
        ><i style="font-size: 25px" class="iconfont icon-youjiantou"></i>
      </li>
    </ul>
  </div>
  <div class="dialog">
    <el-dialog v-model="visible" align-center width="750">
      <div v-for="item in adviceShow" :key="item.advID" class="header">
        <h2 class="title">{{ item.advName }}</h2>
        <div class="tag">
          <span class="auth">作者：{{ item.advAuthor }}</span>
          <span>时间：{{ item.updateAt }}</span>
        </div>
        <p v-html="item.advBody"></p>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { ref } from "vue";
import { findAdviceView } from "@/api/news";
export default {
  props: {
    adviceList: {
      type: Array,
      default: () => [],
    },
  },
  setup() {
    const visible = ref(false);
    const adviceShow = ref([]);
    const showAdvice = (advID) => {
      try {
        visible.value = true;
        findAdviceView(advID).then((data) => {
          adviceShow.value = data;
        });
      } catch (error) {
        console.log(error);
      }
    };
    return { showAdvice, visible, adviceShow };
  },
};
</script>

<style lang="less" scoped>
.outline {
  ul {
    & :hover {
      color: @shColor;
    }
    li {
      display: flex;
      align-items: center;

      height: 50px;
      font-size: 15px;
      line-height: 50px;
      padding-left: 50px;
      border-bottom: 1px solid #dedede;
      & :hover {
        cursor: pointer;
        color: @shColor;
      }
      i {
        line-height: 50px;
      }
      //background: #dedede;
    }
  }
}
.dialog {
  .header {
    .title {
      text-align: center;
      margin-bottom: 25px;
    }
    .tag {
      display: flex;
      justify-content: center;
      margin-bottom: 25px;
      .auth {
        display: inline-block;
        margin-right: 15px;
      }
    }
  }
}
.active {
  color: @shColor;
}
</style>
